import "./documentRepo.css";
import { ReactComponent as SearchIcon } from "../../assets/search-short-handle.svg";
import { List, Button, Checkbox, Divider, Pagination, Input, Select, Spin, Tooltip } from 'antd';
import TextArea from "antd/es/input/TextArea";
import React, { useState , useEffect } from 'react';
import { ReactComponent as ArrowRight } from "../../assets/arrow-right.svg";
import { ReactComponent as ArrowLeft } from "../../assets/arrow-left.svg";
import { ReactComponent as Download } from "../../assets/download.svg";
import { ReactComponent as Lock } from "../../assets/lockPurple.svg";
import { ReactComponent as Rectangle } from "../../assets/Rectangle.svg";
import { ReactComponent as Filters } from "../../assets/Filters.svg";
import { Tooltip as AntTooltip } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { downloadDocument } from "../../store/documents/actions";
import { isEmpty } from "lodash";
import { renderOptions } from "../../util/basicRenders";
import { labelOfFramework } from "../../util/labelOf";

const DocumentRepo = () => {

  const dispatchito = useDispatch();
  const [Loading, setLoading] = useState(true);
  const [renderLoading, setRenderLoading] = useState(false);

  const obligations = useSelector(state => state.obligations.obligations ?? []);
  const intObligations = useSelector(state => state.internalObligations.internalObligations ?? []);
  const users = useSelector(state => state.organizations.usersData);
  const [searchValue, setSearchValue] = useState("");

  const mainObligations = useSelector(state => state.documents?.mainObligations ?? {});
  const filteredMainObligations = Object.fromEntries(
    Object.entries(mainObligations)?.filter(([key, value]) => value.length >= 1)
  );
  // console.log("mainObligations:",filteredMainObligations);
  const internalObligations = useSelector(state => state.documents?.internalObligations ?? {});
  const filteredInternalObligations = Object.fromEntries(
    Object.entries(internalObligations)?.filter(([key, value]) => value.length >= 1)
  );

  const allObligations = [...Object.values(filteredMainObligations), ...Object.values(filteredInternalObligations)];

  const firstLoading = useSelector(state => state.documents.loading);
  const user = useSelector(state => state.user);

  const [ shownObligations, setShownObligations] = useState([]);

  const [ entered, setEntered] = useState(false);
  useEffect(()=>{
    if(allObligations?.length!=0 && !entered){
      setShownObligations(allObligations);
      setEntered(true);
    }
  },[allObligations])

  const organizationId = useSelector(state => state.organizations.organizationId);
  const [firstRender, setFirstRender] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [IDoptions, setIDOptions] = useState([]);
  const [frameworkOptions, setFrameworkOptions] = useState([]);
  const [id, setId] = useState(null);
  const [type, setType] = useState(null);
  const [framework, setFramework] = useState(null);
  const [assessment, setAssessment] = useState(null);
  const [assignee, setAssignee] = useState(null);
  const [confidentiality, setConfidentiality] = useState(null);
  console.debug("setFramework:",framework);

useEffect(()=>{
  if((Object.keys(mainObligations).length || Object.keys(internalObligations).length) && !firstRender){
    setRenderLoading(!renderLoading);
    setShownObligations(allObligations);
    // console.log("allObligations:",allObligations);
    setCurrentPage(1);
  }
  if(Object.keys(mainObligations).length || Object.keys(internalObligations).length){
    setFirstRender(false);
  }
}, [organizationId, mainObligations, internalObligations]);

const firstCell = (index) => {  //an einai to proto keli (0) h an to index einai pollaplasio tou 6 kai to doc emfanizetai proto
  if(index === 0){
    return true;
  }
  if(index%6 === 0){
    return true;
  }
  return false;
}
let index = 0;
const [arrayOfObjects, setArrayOfObjects] = useState([]);
// console.log("shownObligations:",shownObligations);
useEffect(()=>{
  if(shownObligations?.length>0 || (shownObligations?.length===0 && (searchTerm.length || assignee || assessment || type || confidentiality ||!firstRender))){
    
    var tempArray = [];
    for (let i = 0; i < shownObligations.length; i++) {
      for (let j = 0; j < shownObligations[i].length; j++) {
        const obligation = obligations.find(obl => obl._id==shownObligations[i][j].obligation_id);
        const intObligation = intObligations.find(obl => obl._id==shownObligations[i][j].obligation_id);
        const obligationExists = tempArray.some(obj => obj.obligation === shownObligations[i][j].obligation_id);
        // console.log("obligation:",obligations.find(item=>item.code==="000906"));
        const obj = {
          obligation: !obligationExists ? 
                        obligation ? 
                          obligation._id : 
                          intObligation?._id : firstCell(index) ? 
                            obligation ? 
                              obligation._id : 
                              intObligation?._id : 
                              "",
          obligation_description: !obligationExists ? 
                                    obligation ? 
                                      obligation.description : 
                                      intObligation?.description : 
                                      firstCell(index) ? obligation ? 
                                        obligation.description : 
                                        intObligation?.description : 
                                        "",
          obligation_law: !obligationExists ? 
                            obligation ? 
                              obligation.law_title : 
                              "-" : firstCell(index) ? 
                                obligation ? 
                                obligation.law_title : 
                                "-" : 
                                "",
          obligation_paragraph: !obligationExists ? 
                                  obligation ? 
                                    obligation.paragraph!=="undefined" ? 
                                      obligation.paragraph : "-" : "-" : firstCell(index) ? 
                                        obligation ? obligation.paragraph : 
                                        "-" : 
                                        "",
          obligation_article: !obligationExists ? 
                                obligation ? 
                                  obligation.article!=="undefined" ? 
                                    obligation.article : "-" : "-" : firstCell(index) ? 
                                      obligation ?  
                                        obligation.article!=="undefined" ? 
                                          obligation.article : 
                                          "-" : 
                                          "-" : 
                                          "",
          obligation_parent_id: !obligationExists? 
                                  obligation ? 
                                    obligation.parent_id : 
                                    "1" : firstCell(index) ? 
                                      obligation ? obligation.parent_id : 
                                      "1" : 
                                      "",
          obligation_code:  !obligationExists ? 
                              obligation ? 
                                obligation.code : 
                                intObligation?.code : firstCell(index) ? 
                                  obligation ? 
                                    obligation.code : 
                                    intObligation?.code : 
                                    "",
          obligation_assessment:  !obligationExists ? 
                                    obligation ? 
                                      obligation.assessment : 
                                      intObligation?.assessment : 
                                      firstCell(index) ? 
                                        obligation ? 
                                          obligation.assessment : 
                                          intObligation?.assessment : 
                                          "",
          obligation_framework: !obligationExists ? 
                                  obligation ? 
                                    labelOfFramework(obligation.mainCategory) :
                                      "-" : firstCell(index) ? 
                                        obligation ? 
                                          labelOfFramework(obligation.mainCategory) : 
                                            "-" : 
                                            "",
          obligation_code:  !obligationExists ? 
                              obligation ? 
                                obligation.code : 
                                intObligation?.code : 
                                firstCell(index) ? 
                                  obligation ? 
                                    obligation.code : 
                                    intObligation?.code : 
                                    "",
          obligation_assigned_user: !obligationExists ? 
                                      obligation?.isAssigned ? 
                                        users.filter(user=> user._id === obligation.user_id)[0]?.firstName +" "+ users.filter(user=> user._id === obligation.user_id)[0]?.lastName: 
                                        intObligation?.isAssigned ? 
                                          users.filter(user=> user._id === intObligation.user_id)[0]?.firstName +" "+ users.filter(user=> user._id === intObligation.user_id)[0]?.lastName:  
                                          "-" : firstCell(index) ? 
                                            obligation?.isAssigned ? 
                                              users.filter(user=> user._id === obligation.user_id)[0]?.firstName +" "+ users.filter(user=> user._id === obligation.user_id)[0]?.lastName: 
                                              intObligation?.isAssigned ? 
                                                users.filter(user=> user._id === intObligation.user_id)[0]?.firstName +" "+ users.filter(user=> user._id === intObligation.user_id)[0]?.lastName:    
                                                "-" : 
                                                  "",
          obligation_assigned_user_id:  obligation ? 
                                          obligation.isAssigned ? 
                                            users.filter(user=> user._id === obligation.user_id)[0]?._id: 
                                            "-" : 
                                            intObligation?.isAssigned ? 
                                              users.filter(user=> user._id === intObligation.user_id)[0]?._id : 
                                              "-",
          obligation_type:  !obligationExists ? 
                              obligation ? 
                                "Main Obligation" : 
                                "Internal Obligation" : 
                                firstCell(index) ? 
                                  obligation ? 
                                    "Main Obligation" : 
                                    "Internal Obligation" : 
                                    "",
          
          restricted: shownObligations[i][j].userPermissions.length===0 ? false : true,
          file: shownObligations[i][j].name,
          doc_id: shownObligations[i][j].doc_id,
          userPermissions: shownObligations[i][j]?.userPermissions,
          docUploader: shownObligations[i][j]?.user_id
        };
        tempArray.push(obj);
        index++;
      }
    }
    setArrayOfObjects(tempArray);
    tempArray = [];
  }
},[shownObligations, searchTerm]);

  console.debug("arrayofobjects:",arrayOfObjects); 

  useEffect(()=>{
    if(arrayOfObjects.length !== 0 && !id && !framework && !type && !assessment && !assignee && !confidentiality){
      const uniqueIDOptions = [...new Set(arrayOfObjects.map(item => item.obligation_code).filter(value => value !== ""))];
      setIDOptions(uniqueIDOptions);
      const uniqueFrameworkOptions = [...new Set(arrayOfObjects.map(item => item.obligation_framework).filter(value => value !== "" && value !== "-"))];
      setFrameworkOptions(uniqueFrameworkOptions);

      setLoading(false);
    }
  },[arrayOfObjects]);

  const { Search } = Input;
  const prefix = <SearchIcon style={{ fontSize: 24, color: "purple" }} />;
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 6;
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = currentPage * pageSize;
  const currentData = arrayOfObjects && arrayOfObjects.slice(startIndex, endIndex);
  const [selectedItems, setSelectedItems] = useState([]);
  const [showFilters, setShowFilters] = useState(false);

  const Titles = ({item}) => (
    <div style={{textAlign:"left"}}>
      <Divider style={{ margin: "0.5rem 0" }} />
      <div style={{marginLeft:"58px"}}>
        <AntTooltip
          title={() => (
            <div style={{ whiteSpace: 'pre-wrap' }}>
              {item.obligation_law}
            </div>
          )}
          arrow={false}
          overlayClassName="description-tooltip"
          mouseEnterDelay={0.5}
          placement="bottomLeft"
        >
          <TextArea
            disabled={true}
            bordered={false}
            value={
              item.obligation_law.length > 13
                ? item.obligation_law.substring(0, 13) + "..."
                : item.obligation_law
            }
            autoSize={{ minRows: 1, maxRows: 1 }}
            style={{ marginLeft:"-65px", fontSize:"0.75rem", fontWeight:  '500' }}
          />
        </AntTooltip>
        {/* <text >{item.obligation_law}</text> */}
        <AntTooltip
          title={() => (
            <div style={{ whiteSpace: 'pre-wrap' }}>
              {item.obligation_article}
            </div>
          )}
          arrow={false}
          overlayClassName="description-tooltip"
          mouseEnterDelay={0.5}
          placement="bottomLeft"
        >
          <TextArea
            disabled={true}
            bordered={false}
            value={
              item.obligation_article?.length > 10
                ? item.obligation_article.substring(0, 10) + "..."
                : item.obligation_article
            }
            autoSize={{ minRows: 1, maxRows: 1 }}
            style={{ position: "absolute", left: "9.2rem", fontSize:"0.75rem", fontWeight:  '500' }}
          />
        </AntTooltip>
        {/* <text style={{position:"absolute", left:"12.5rem"}}>{item.obligation_article}</text> */}
        <AntTooltip
          title={() => (
            <div style={{ whiteSpace: 'pre-wrap' }}>
              {item.obligation_paragraph}
            </div>
          )}
          arrow={false}
          overlayClassName="description-tooltip"
          mouseEnterDelay={0.5}
          placement="bottomLeft"
        >
          <TextArea
            disabled={true}
            bordered={false}
            value={
              item.obligation_paragraph?.length > 13
                ? item.obligation_paragraph.substring(0, 13) + "..."
                : item.obligation_paragraph
            }
            autoSize={{ minRows: 1, maxRows: 1 }}
            style={{ position: "absolute", left: "16rem", fontSize:"0.75rem", fontWeight:  '500' }}
          />
        </AntTooltip>
        {/* <text style={{position:"absolute", left:"25rem"}}>{item.obligation_paragraph}</text> */}
        <AntTooltip
          title={() => (
            <div style={{ whiteSpace: 'pre-wrap' }}>
              {item.obligation_framework}
            </div>
          )}
          arrow={false}
          overlayClassName="description-tooltip"
          mouseEnterDelay={0.5}
          placement="bottomLeft"
        >
          <TextArea
            disabled={true}
            bordered={false}
            value={
              item.obligation_framework?.length > 18
                ? item.obligation_framework.substring(0, 18) + "..."
                : item.obligation_framework
            }
            autoSize={{ minRows: 1, maxRows: 1 }}
            style={{ position: "absolute", left: "26rem", fontSize:"0.75rem", fontWeight:  '500' }}
          />
        </AntTooltip>
        <AntTooltip
          title={() => (
            <div style={{ whiteSpace: 'pre-wrap' }}>
              {item.obligation_code}
            </div>
          )}
          arrow={false}
          overlayClassName="description-tooltip"
          mouseEnterDelay={0.5}
          placement="bottomLeft"
        >
          <TextArea
            disabled={true}
            bordered={false}
            value={
              item.obligation_code?.length > 17
                ? item.obligation_code.substring(0, 20) + "..."
                : item.obligation_code
            }
            autoSize={{ minRows: 1, maxRows: 1 }}
            style={{ position: "absolute", left: "37.8rem", fontSize:"0.75rem", fontWeight:  '500' }}
          />
        </AntTooltip>
        <AntTooltip
          title={() => (
            <div style={{ whiteSpace: 'pre-wrap' }}>
              {item.obligation_type}
            </div>
          )}
          arrow={false}
          overlayClassName="description-tooltip"
          mouseEnterDelay={0.5}
          placement="bottomLeft"
        >
          <TextArea
            disabled={true}
            bordered={false}
            value={
              item.obligation_type?.length > 19
                ? item.obligation_type.substring(0, 19) + "..."
                : item.obligation_type
            }
            autoSize={{ minRows: 1, maxRows: 1 }}
            style={{ position: "absolute", left: "45.3rem", fontSize:"0.75rem", fontWeight:  '500' }}
          />
        </AntTooltip>
        <AntTooltip
          title={() => (
            <div style={{ whiteSpace: 'pre-wrap' }}>
              {item.obligation_assigned_user}
            </div>
          )}
          arrow={false}
          overlayClassName="description-tooltip"
          mouseEnterDelay={0.5}
          placement="bottomLeft"
        >
          <TextArea
            disabled={true}
            bordered={false}
            value={
              item.obligation_assigned_user?.length > 20
                ? item.obligation_assigned_user.substring(0, 20) + "..."
                : item.obligation_assigned_user
            }
            autoSize={{ minRows: 1, maxRows: 1 }}
            style={{ position: "absolute", left: "55rem", fontSize:"0.75rem", fontWeight:  '500' }}
          />
        </AntTooltip>
      </div>
    </div>
  )

  const SubTitles = () => (
    <div style={{textAlign:"left",marginTop:"1.25rem"}}>
      <b style={{color:"#725798", 
                fontFamily: "Roboto",
                fontSize: "12px",
                fontWeight: "700",
                lineHeight: "12px",
                textAlign: "left",
                // marginLeft:"60px",
                }}
      >Law</b>
      <b style={{color:"#725798", 
                fontFamily: "Roboto",
                fontSize: "12px",
                fontWeight: "700",
                lineHeight: "12px",
                textAlign: "left",
                marginLeft:"136px",
                }}
      >Article</b>
      <b style={{color:"#725798", 
              fontFamily: "Roboto",
              fontSize: "12px",
              fontWeight: "700",
              lineHeight: "12px",
              textAlign: "left",
              marginLeft:"74px",
              }}
      >Paragraph</b>
      <b style={{color:"#725798", 
                fontFamily: "Roboto",
                fontSize: "12px",
                fontWeight: "700",
                lineHeight: "12px",
                textAlign: "left",
                marginLeft:"105px",
                }}
      >Framework</b>
      <b style={{color:"#725798", 
              fontFamily: "Roboto",
              fontSize: "12px",
              fontWeight: "700",
              lineHeight: "12px",
              textAlign: "left",
              marginLeft:"128px",
              }}
      >ID</b>
      <b style={{color:"#725798", 
              fontFamily: "Roboto",
              fontSize: "12px",
              fontWeight: "700",
              lineHeight: "12px",
              textAlign: "left",
              marginLeft:"108px",
              }}
      >Type</b>
      <b style={{color:"#725798", 
              fontFamily: "Roboto",
              fontSize: "12px",
              fontWeight: "700",
              lineHeight: "12px",
              textAlign: "left",
              marginLeft:"128px",
              }}
      >Assignee</b>
    </div>
  )

  const handlePageChange = page => {
    setCurrentPage(page);
    setChecked(false);
    setSelectedItems([]);
  };

  const [checked, setChecked] = useState(false);
  const onAllCheckboxChange = () => {
    if(checked){
      setSelectedItems([]);
      setChecked(false);
    }
    else{
      const allowedData = currentData?.filter(item => {
        const userIsOwner = user?.userId === item?.docUploader
        const fileisPublic = isEmpty(item?.userPermissions)
        const accessAllowed = userIsOwner || fileisPublic || item?.userPermissions?.includes(user?.userId);
        return accessAllowed
      })
      const uniqueValuesSet = new Set([...allowedData]);
      const uniqueValuesArray = Array.from(uniqueValuesSet);
      setSelectedItems(uniqueValuesArray);
      setChecked(true);
    }
  };

  const handleMassDownload = async (e) => {
    for (const item of selectedItems) {
      await dispatchito(
        downloadDocument({
          docId: item?.doc_id,
          user,
          callback: (linkSource = '', filename = 'downloaded-file.pdf') => {
            const downloadLink = document.createElement("a");
            downloadLink.href = linkSource;
            downloadLink.download = filename;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
          }
        })
      );
    }
    setSelectedItems([]);
    setChecked(false);
  };
  
  useEffect(() => {
    setLoading(false);
  }, [shownObligations]);

  // const [sorted, setSorted] = useState(false);
  // const handleSort = () => {
  //   setLoading(true);
  //   const sortedObligations = [...shownObligations].sort((a, b) => {
  //     const obligationA = obligations.find(obl => obl._id===a[0].obligation_id);
  //     const obligationB = obligations.find(obl => obl._id===b[0].obligation_id);
  //     const lawA = obligationA?.law_title.toUpperCase();
  //     const lawB = obligationB?.law_title.toUpperCase();
  //     if (lawA && lawB){
  //       if (lawA < lawB) {
  //         if(sorted){
  //           return -1;
  //         } else {
  //           return 1;
  //         }
  //       }
  //       if (lawA > lawB) {
  //         if(sorted){
  //           return 1;
  //         } else {
  //           return -1
  //         }
  //       }
  //     }
  //     return 0;
  //   });
  //   setShownObligations(sortedObligations);
  //   setSorted(!sorted);
  // };

  const onCheckboxChange = (event, item) => {
    const index = selectedItems?.findIndex(selectedItem => selectedItem.obligation === item.obligation)
    const index2 = selectedItems?.findIndex(selectedItem => selectedItem.file === item.file)
    if(index !== -1 && index2 !== -1){
      const updatedSelectedObligations = selectedItems?.filter((selectedItem) => selectedItem.obligation !== item.obligation || selectedItem.file !== item.file);
      setSelectedItems(updatedSelectedObligations);
    } else {
      setSelectedItems([...selectedItems, item]);
    }  
  };
  
  const renderItem = (item) => { 
    console.debug({item})
    const userIsOwner = user?.userId === item?.docUploader
    const fileisPublic = isEmpty(item?.userPermissions)
    const accessAllowed =
      userIsOwner ||
      fileisPublic ||
      item?.userPermissions?.includes(user?.userId);
    return (
    <List.Item
      style={{border:"none"}}
    >
      <div className="list-items-area">
        <List.Item.Meta
          title={item.obligation!=="" ? <Titles item={item}></Titles> : ""}
          description={(
            <div style={{backgroundColor:"#F1F1F1", color:"#725798", borderRadius:"0.5rem", height:"3rem", marginBottom:"-1.563rem"}}>
                <div style={{marginLeft:"-69.375rem", marginBottom:"-6.25rem", paddingTop:"0.938rem"}}>
                    <Checkbox
                      style={{position:"absolute",left:"1rem", marginTop:"-2px"}}
                      onChange={e => onCheckboxChange(e, item)}
                      disabled = {!accessAllowed}
                      checked = {accessAllowed ? selectedItems.findIndex(selectedItem => selectedItem.obligation === item.obligation)!==-1 && selectedItems.findIndex(selectedItem => selectedItem.file === item.file)!==-1 : false}
                    ></Checkbox>
                    <div style={{position:"absolute",left:"6.25rem"}}>
                      {item.file}
                    </div>
                </div>
                <Button 
                  className="download-doc-button"
                  style={{visibility: accessAllowed ? "visible" : "hidden", marginTop:"5.938rem", marginLeft:"55rem", backgroundColor:"#F1F1F1", border:"none"}}
                  onClick={e => {
                    e.stopPropagation();
                    dispatchito(
                      downloadDocument({
                        docId: item?.doc_id,
                        user,
                        callback: (linkSource='', filename='downloaded-file.pdf') => {
                          console.debug({ linkSource });
                          const downloadLink = document.createElement("a");
                          downloadLink.href = linkSource;
                          downloadLink.download = filename; //without this it just opens it in browser instead of downloading it
                          document.body.appendChild(downloadLink); // Required for Firefox
                          downloadLink.click();
                          document.body.removeChild(downloadLink);
                        }
                      })
                    );
                  }}
                >
                    <Download/>
                    <b style={{paddingLeft:"0.313rem", color:"#725798"}}>Download</b>
                </Button>
                <div style={{marginTop:"-1.5rem", marginLeft:"72rem", visibility: !fileisPublic ? "visible" : "hidden"}}>
                  <Lock/>
                </div>
            </div>
          )}
        />
      </div>
    </List.Item>
  )};
  
  const DownloadList = () => (
    <>
      <List
        itemLayout="vertical"
        dataSource={currentData}
        renderItem={renderItem}
        style={{ border: 'none' }}
      />
      {selectedItems.length>1 ?
        <Button 
          className="download-doc-button"
          style={{marginTop:"3.125rem", backgroundColor:"#F1F1F1", border:"none", marginLeft:"-80rem"}}
          onClick={e => handleMassDownload(e)}
        >
          <Download/>
          <b style={{paddingLeft:"0.313rem", color:"#725798"}}>Download</b>
        </Button>
        :
        <div style={{marginTop:"5.625rem"}}></div>
      }
      <Divider style={{ margin:"0.5rem 0"}} />
      <Pagination
          current={currentPage}
          total={arrayOfObjects.length}  
          pageSize={pageSize}
          hideOnSinglePage={true}
          onChange={handlePageChange}
          itemRender={(page, type, originalElement) => {
            if (type === "next") {
              return (
                <button
                  id="audit-pagination-next"
                  className="ant-pagination-item-link"
                  type="button"
                  tabindex="-1"
                >
                  <span
                    role="img"
                    aria-label="right"
                    className="anticon anticon-right"
                    id="audit-page-icon-right"
                  >
                    <span className="pagination-label">Next</span>
                    <ArrowRight />
                  </span>
                </button>
              );
            } else if (type === "prev") {
              return (
                <button
                  id="audit-pagination-prev"
                  type="button"
                  className="ant-pagination-item-link"
                  tabindex="-1"
                >
                  <span
                    role="img"
                    aria-label="left"
                    id="audit-page-icon-left"
                    className="anticon anticon-left"
                  >
                    <ArrowLeft />
                    <span className="pagination-label">Previous</span>
                  </span>
                </button>
              );
            }
            return originalElement;
          }}
        />
      </>
  );

  useEffect(() => {
    if (searchTerm.length>0 || assessment || id || type || framework || assignee) {
      // obligation_assigned_user_id
      //filter arrayOfObjects for internals
      // console.log("code:",typeof(assignee));
      // console.log("internal:",intObligations.find(item=>item.user_id!=="0").user_id.localeCompare(assignee));
      // console.log("obligation:",obligations.find(item=>item.code==="000906"));
      const filtered = intObligations?.filter(obligation => {
        let matches = true;
      
        if (searchTerm) {
          matches = false;
        }
        if (assessment) {
          matches = matches && (obligation?.assessment?.toLowerCase() === assessment.toLowerCase());
        }
        if (id) {
          matches = matches && (obligation?.code === id);
        }
        if (framework) {
          matches = matches && (labelOfFramework(obligation?.mainCategory) === framework);
        }
        if (assignee) {
          matches = matches && (obligation?.user_id.localeCompare(assignee) === 0);
        }
        return matches;
      });
        
      var filteredObligations = [];
      if(filtered.length>0 && type!=="main"){
        // console.log("searchTerm:",filtered.map(obl => obl.obligation));
        filteredObligations = allObligations.filter(obl => filtered.map(obl => obl._id).includes(obl[0].obligation_id));
      } else if (filtered.length===0 && !id && !framework && !assessment && !assignee && !confidentiality && type==="internal"){
        filteredObligations = allObligations.filter(obl => intObligations.map(obl => obl._id).includes(obl[0].obligation_id));
      }

      //filter obligations for mains
        const filteredAll = obligations?.filter(obligation => {
          let matches = true;
        
          if (searchTerm) {
            matches = matches && (obligation?.law_title.toLowerCase().includes(searchTerm.toLowerCase()));
          }
          if (assessment) {
            matches = matches && (obligation?.assessment?.toLowerCase() === assessment.toLowerCase());
          }
          if (id) {
            matches = matches && (obligation?.code === id);
          }
          if (framework) {
            matches = matches && (labelOfFramework(obligation?.mainCategory) === framework);
          }
          if (assignee) {
            matches = matches && (obligation?.user_id.localeCompare(assignee) === 0);
          }
        
          return matches;
        });
        
      var filteredObligationsAll = [];
      if(filteredAll.length>0 && type!=="internal"){
        filteredObligationsAll = allObligations.filter(obl => filteredAll.map(obl => obl._id).includes(obl[0].obligation_id));
      } else if (filteredAll.length===0 && !id && !framework && !assessment && !assignee && !confidentiality && type==="main"){
        filteredObligationsAll = allObligations.filter(obl => obligations.map(obl => obl._id).includes(obl[0].obligation_id));
      }
      // console.log("filteredAll:",filteredObligationsAll);
      //combine them
      const combinedfilteredArrays = [...filteredObligationsAll, ...filteredObligations];
      // console.log("allObligations:",allObligations.map(item=>item.filter(item=>item.userPermissions.length!==0)).filter(item=>item.length!==0));
      // console.log("CONFIDENCIALITY:",confidentiality);
      if(confidentiality==="ra"){
        setShownObligations(combinedfilteredArrays.map(item=>item.filter(item=>item.userPermissions.length!==0)).filter(item=>item.length!==0));
      } else if(confidentiality==="nra"){
        setShownObligations(combinedfilteredArrays.map(item=>item.filter(item=>item.userPermissions.length===0)).filter(item=>item.length!==0));
      } else {
        setShownObligations(combinedfilteredArrays);
      }
      // setSorted(true);
      setCurrentPage(1);
      setSelectedItems([]);
      setChecked(false);
    } else {
      if(confidentiality==="ra"){
        setShownObligations(allObligations.map(item=>item.filter(item=>item.userPermissions.length!==0)).filter(item=>item.length!==0));
      } else if(confidentiality==="nra"){
        setShownObligations(allObligations.map(item=>item.filter(item=>item.userPermissions.length===0)).filter(item=>item.length!==0));
      } else {
        setShownObligations(allObligations);
      }
      // setSorted(true);
      setSelectedItems([]);
      setChecked(false);
    }
  }, [searchTerm, obligations, assessment, id, type, framework, assignee, confidentiality]);
  // console.log("confidentiality:",confidentiality);

  return(
    Loading || renderLoading || firstLoading?
    // false?
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "50px",
      }}
    >
      <Spin size="large" />
    </div>
    :
    <div className="doc-repo-content">
        <div className="search-bar-area">
          <Search
            style={{borderRadius:"0.5rem",borderColor:"#725798", color:"red"}} 
            className="doc-repo-search-bar"
            id={"doc-repo-search-bar"}
            placeholder="Search by Law"
            prefix={prefix}
            allowClear
            size="large"
            enterButton={false}
            value={searchTerm || ""}
            // onSearch={e => setSearchTerm(e)}
            onChange={e => {
              setCurrentPage(1);
              setSearchTerm(e.target.value);
            }}
          />
        </div>
          <Tooltip
            title={showFilters ? 
              <>
                Click here
                <br />
                to hide the filters
              </> 
              :
              <>
                Click here
                <br />
                to show the filters
              </>
            }
            arrow={true}
            color={"#FFFFFF"}
            overlayClassName="filter-tooltip"
            placement="top"
          >
            <div className="filters-icon-area" style={{ marginRight: "-1450px", marginTop: "-20px" }}>
            <Button
              style={{border:"none"}}
              icon={<Filters />}
              onClick={() => setShowFilters(!showFilters)}
            />
            </div>
          </Tooltip>
        {showFilters &&
        <div>
          <div className="filters-bar-area">
            <Select 
              allowClear
              showSearch 
              placeholder="ID" 
              size="large" 
              className="filter" 
              value={id}
              options={IDoptions.map(item => ({
                label: item,
                value: item
              }))}
              onChange={value=>setId(value)}
            />
            <Select 
              allowClear
              placeholder="Obligation Type (Main-Internal)" 
              size="large" 
              className="filter"
              value={type}
              options={[
                {
                  value: 'main',
                  label: 'Main Obligation',
                },
                {
                  value: 'internal',
                  label: 'Internal Obligation',
                },
              ]}
              onChange={value=>setType(value)}
            />
            <Select 
              allowClear
              showSearch 
              placeholder="Framework" 
              size="large" 
              className="filter"
              value={framework}
              options={frameworkOptions.map(item => ({
                label: item,
                value: item
              }))}
              onChange={value=>setFramework(value)}
            />
          </div>
          <div className="filters-bar-area2">
            <Select 
              allowClear
              placeholder="Assessent" 
              size="large" 
              className="filter"
              value={assessment}
              options={[
                {
                  value: "Pending",
                  label: "Pending"
                },
                {
                  value: "Partially",
                  label: "Partially Compliant"
                },
                {
                  value: "Compliant",
                  label: "Compliant"
                },
                {
                  value: "Non-Compliant",
                  label: "Non Compliant"
                },
                {
                  value: "na",
                  label: "N/A"
                }
              ]}
              onChange={value=>setAssessment(value)}
            />
            <Select
              virtual={false}
              className="filter"
              size="large" 
              disabled={false}
              showSearch
              onSearch={setSearchValue}
              allowClear
              // allowClear={false}
              value={assignee}
              placeholder="Assignee" 
              optionFilterProp="children"
              onChange={value => {
                setSearchValue("");
                setAssignee(value);
                // addUser(value);
              }}
              filterOption={false}
            >
              {renderOptions(searchValue, users)}
            </Select>
            <Select 
              allowClear
              placeholder="Document Type" 
              size="large" 
              className="filter"
              value={confidentiality}
              options={[
                {
                  value: 'ra',
                  label: 'Restricted Access',
                },
                {
                  value: 'nra',
                  label: 'Non Restricted Access',
                },
              ]}
              onChange={value=>setConfidentiality(value)}
            />
          </div>
        </div>}
        <div className="title-area" style={{ display: "flex", justifyContent: "left", alignItems: "left"}}>
            <h1 className="title" style={{color:"#725798", fontSize:"1.625rem"}}>Search Results</h1>
        </div>
        <div>
            <Divider style={{ margin: "0.5rem 0" }} />
          <div>
            <div className="check-box-area">
              <Checkbox
                checked={checked}
                onChange={e => onAllCheckboxChange(e)}
              ></Checkbox>
            </div>
            <span
              style={{
                position:"absolute",
                color:"#725798",
                fontFamily: "Roboto",
                fontSize: "12px",
                fontWeight: "700",
                lineHeight: "14.06px",
                textAlign: "left",
                marginTop: "-1rem",
                marginLeft: "25rem"
              }}
            >
              Actions
            </span>
            <span
              style={{
                position:"absolute",
                color:"#725798",
                fontFamily: "Roboto",
                fontSize: "12px",
                fontWeight: "700",
                lineHeight: "14.06px",
                textAlign: "left",
                marginTop: "-1rem",
                marginLeft: "35rem"
              }}
            >
              Confidentiality
            </span>
          </div>
          <Divider style={{ margin: "0.5rem 0" }} />
        </div>
        <div>
          <SubTitles></SubTitles>
        </div>
        <DownloadList />
    </div>
  )
}

export default DocumentRepo;
